// extracted by mini-css-extract-plugin
export default {"newpassword":"password_newpassword__ek51S","button":"password_button__9+Wk1"};